import { createFrontendModule } from '@backstage/frontend-plugin-api';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';

const catalogGraphPage = catalogGraphPlugin
  .getExtension('page:catalog-graph')
  .override({
    params: { noHeader: true },
  });

export const catalogGraphPageModule = createFrontendModule({
  pluginId: 'catalog-graph',
  extensions: [catalogGraphPage],
});
